import React, { Suspense } from 'react'

import { useTranslation } from 'react-i18next'
import { Await, useLoaderData, useNavigation } from 'react-router-dom'

import LoadingMessage from '@components/LoadingMessage'
import SharedScoresView from '@components/myScores/SharedScoresView'
import LoadingSpinner from '@components/shared/LoadingSpinner'
import { SharedScoresLoaderResponse } from '@pages/home/loaders/sharedScores.loader'
import { usePageTitle } from '@providers/LayoutProvider'

const SharedScoresPage: React.FC = () => {
  const { t } = useTranslation()
  const data = useLoaderData() as SharedScoresLoaderResponse
  const navigation = useNavigation()

  usePageTitle(t('titles.sharedScores'))

  const isReloading =
    navigation.state === 'loading' &&
    navigation.formData != null &&
    navigation.location.pathname === '/home/sharedWithMe'

  return (
    <>
      {isReloading && <LoadingMessage />}
      <Suspense
        fallback={
          <>
            {/* Spacer */}
            <div className="h-16 w-full" />

            <LoadingSpinner />
          </>
        }>
        <Await resolve={data.sharedScores}>
          {(sharedScoresResp) => (
            <SharedScoresView initialData={sharedScoresResp} order={data.order} />
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default SharedScoresPage
